import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";
import Modifiers from "../models/Modifiers";

export default class BlockHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "block":
                return this.handleBlock(model, params);
            case "block/confirm":
                return this.handleConfirm(model, params);
            case "block/cancel":
                return this.handleCancel(model, params);
            case "block/result":
                return this.handleResult(model, params);
            default:
                return model;
        }
    }

    private handleResult(model: DiscussionModel, comment: number): DiscussionModel {
        model = Modifiers.blockComment(model, comment);
        return model;
    }

    private handleBlock(model: DiscussionModel, comment: number): DiscussionModel {
        model = Modifiers.showBlockModal(model, comment);
        return model;
    }

    private handleConfirm(model: DiscussionModel, params: any): DiscussionModel {

        const comment = model.getBlockComment();

        this.fetch("block", {
            project: model.getProject(),
            discussion: model.getDiscussion(),
            comment: comment,
        }).then((response) => {
            if (response.result) {
                this.dispatch("block/result", comment);
            } else {
                this.dispatch("error", 6);
            }
        }).catch(() => {
            this.dispatch("error", 6);
        });

        model = Modifiers.hideBlockModal(model);
        return model;

    }

    private handleCancel(model: DiscussionModel, params: any): DiscussionModel {
        model = Modifiers.hideBlockModal(model);
        return model;
    }

}